import React from 'react';
import { Loader2 } from 'lucide-react';

// Una sola forma de "cargando" en la parte administrativa.
export default function Cargando({ texto = 'Cargando…', className = 'py-16' }) {
  return (
    <div role="status" className={`flex items-center justify-center gap-2 text-sm text-muted-foreground ${className}`}>
      <Loader2 size={20} className="animate-spin text-primary" aria-hidden="true" /> {texto}
    </div>
  );
}
